import { Client, Alert, User, ServiceRecord } from '../types/shelter';
import johnPhoto from '@/assets/client-john.jpg';
import michaelPhoto from '@/assets/client-michael.jpg';
import robertPhoto from '@/assets/client-robert.jpg';
import davidPhoto from '@/assets/client-david.jpg';
import carlosPhoto from '@/assets/client-carlos.jpg';
import anthonyPhoto from '@/assets/client-anthony.jpg';
import marcusPhoto from '@/assets/client-marcus.jpg';
import stevenPhoto from '@/assets/client-steven.jpg';
import { ROLES } from '@/constants/roles';

// Demo UUIDs for consistent demo data
export const DEMO_IDS = {
  // User IDs
  users: {
    staff: 'a0000000-0000-0000-0000-000000000001',
    supervisor: 'a0000000-0000-0000-0000-000000000002',
    superadmin: 'a0000000-0000-0000-0000-000000000003',
    manager: 'a0000000-0000-0000-0000-000000000004',
  },
  // Site IDs
  sites: {
    sleepOut: 'b0000000-0000-0000-0000-000000000001',
    bedstuty: 'b0000000-0000-0000-0000-000000000002',
    friendsFamily: 'b0000000-0000-0000-0000-000000000003',
    bre: 'b0000000-0000-0000-0000-000000000004',
  },
  // Room IDs
  rooms: {
    r101: 'c0000000-0000-0000-0000-000000000101',
    r102: 'c0000000-0000-0000-0000-000000000102',
    r103: 'c0000000-0000-0000-0000-000000000103',
    r104: 'c0000000-0000-0000-0000-000000000104',
    r105: 'c0000000-0000-0000-0000-000000000105',
    r106: 'c0000000-0000-0000-0000-000000000106',
    r107: 'c0000000-0000-0000-0000-000000000107',
    r108: 'c0000000-0000-0000-0000-000000000108',
    r201: 'c0000000-0000-0000-0000-000000000201',
    r204: 'c0000000-0000-0000-0000-000000000204',
    r205: 'c0000000-0000-0000-0000-000000000205',
    r401: 'c0000000-0000-0000-0000-000000000401',
  },
};

export const mockUsers: User[] = [
  {
    id: DEMO_IDS.users.staff,
    username: 'staff',
    role: ROLES.STAFF,
    name: 'Staff Member'
  },
  {
    id: DEMO_IDS.users.supervisor,
    username: 'supervisor',
    role: ROLES.SUPERVISOR,
    name: 'Administrator'
  },
  {
    id: DEMO_IDS.users.superadmin,
    username: 'superadmin',
    role: ROLES.SUPER_ADMIN,
    name: 'Super Administrator'
  },
  {
    id: DEMO_IDS.users.manager,
    username: 'manager',
    role: ROLES.MANAGER,
    name: 'Rachel Morrison'
  }
];

const getTodayDate = () => new Date().toISOString().split('T')[0];

// Client UUIDs
const CLIENT_IDS = {
  c1: 'd0000000-0000-0000-0000-000000000001',
  c2: 'd0000000-0000-0000-0000-000000000002',
  c3: 'd0000000-0000-0000-0000-000000000003',
  c4: 'd0000000-0000-0000-0000-000000000004',
  c5: 'd0000000-0000-0000-0000-000000000005',
  c6: 'd0000000-0000-0000-0000-000000000006',
  c7: 'd0000000-0000-0000-0000-000000000007',
  c8: 'd0000000-0000-0000-0000-000000000008',
};

export const mockClients: Client[] = [
  {
    id: CLIENT_IDS.c1,
    name: 'John D. Martinez',
    age: 34,
    room: '204A',
    room_id: DEMO_IDS.rooms.r204,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-in',
    caseWorker: 'Sarah Johnson',
    phone: '(555) 123-4567',
    email: 'john.martinez@email.com',
    allergies: ['Nuts', 'Shellfish'],
    alerts: ['Mail received', 'ILP Reminder'],
    checkInTime: '2025-09-04T08:30:00Z',
    lastActivity: '2025-09-04T08:30:00Z',
    photo: '/src/assets/client-john.jpg',
    services: {
      daily: { date: getTodayDate(), metro: 1, laundry: 0, meal: 2, juice: 1 },
      total: { date: getTodayDate(), metro: 25, laundry: 8, meal: 45, juice: 32 }
    }
  },
  {
    id: CLIENT_IDS.c2,
    name: 'Michael B. Thompson',
    age: 45,
    room: '102A',
    room_id: DEMO_IDS.rooms.r102,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-out',
    caseWorker: 'Michael Chen',
    phone: '(555) 234-5678',
    alerts: ['Received Transit', '2 Lunch'],
    checkOutTime: '2025-09-04T06:45:00Z',
    lastActivity: '2025-09-04T06:45:00Z',
    photo: '/src/assets/client-michael.jpg',
    services: {
      daily: { date: getTodayDate(), metro: 1, laundry: 0, meal: 1, juice: 0 },
      total: { date: getTodayDate(), metro: 12, laundry: 5, meal: 38, juice: 28 }
    }
  },
  {
    id: CLIENT_IDS.c3,
    name: 'Robert L. Johnson',
    age: 28,
    room: '201A',
    room_id: DEMO_IDS.rooms.r201,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-in',
    caseWorker: 'Jennifer Davis',
    phone: '(555) 345-6789',
    alerts: ['Received Laundry card', '3 Juice'],
    lastActivity: '2025-09-04T09:15:00Z',
    photo: '/src/assets/client-robert.jpg',
    services: {
      daily: { date: getTodayDate(), metro: 0, laundry: 1, meal: 2, juice: 3 },
      total: { date: getTodayDate(), metro: 18, laundry: 7, meal: 42, juice: 35 }
    }
  },
  {
    id: CLIENT_IDS.c4,
    name: 'David A. Wilson',
    age: 52,
    room: '101A',
    room_id: DEMO_IDS.rooms.r101,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-in',
    caseWorker: 'Lisa Rodriguez',
    phone: '(555) 456-7890',
    alerts: ['Mail received', 'Received Transit'],
    checkInTime: '2025-09-04T07:20:00Z',
    lastActivity: '2025-09-04T07:20:00Z',
    photo: '/src/assets/client-david.jpg',
    services: {
      daily: { date: getTodayDate(), metro: 1, laundry: 0, meal: 1, juice: 0 },
      total: { date: getTodayDate(), metro: 31, laundry: 12, meal: 67, juice: 41 }
    }
  },
  {
    id: CLIENT_IDS.c5,
    name: 'Carlos E. Rodriguez',
    age: 31,
    room: '205B',
    room_id: DEMO_IDS.rooms.r205,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-in',
    caseWorker: 'Maria Gonzalez',
    phone: '(555) 567-8901',
    alerts: ['ILP Reminder', '2 Lunch'],
    checkInTime: '2025-09-04T08:45:00Z',
    lastActivity: '2025-09-04T08:45:00Z',
    photo: '/src/assets/client-carlos.jpg',
    services: {
      daily: { date: getTodayDate(), metro: 0, laundry: 1, meal: 2, juice: 1 },
      total: { date: getTodayDate(), metro: 14, laundry: 6, meal: 28, juice: 22 }
    }
  },
  {
    id: CLIENT_IDS.c6,
    name: 'Anthony J. Davis',
    age: 39,
    room: '108A',
    room_id: DEMO_IDS.rooms.r108,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-in',
    caseWorker: 'Dr. Patricia Williams',
    phone: '(555) 678-9012',
    alerts: ['Received Laundry card', '3 Juice'],
    checkInTime: '2025-09-04T09:30:00Z',
    lastActivity: '2025-09-04T10:15:00Z',
    photo: '/src/assets/client-anthony.jpg',
    services: {
      daily: { date: getTodayDate(), metro: 0, laundry: 0, meal: 1, juice: 2 },
      total: { date: getTodayDate(), metro: 22, laundry: 9, meal: 51, juice: 33 }
    }
  },
  {
    id: CLIENT_IDS.c7,
    name: 'Marcus T. Brown',
    age: 26,
    room: undefined,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'unbedded',
    caseWorker: 'James Mitchell',
    phone: '(555) 789-0123',
    alerts: ['Mail received', 'ILP Reminder'],
    lastActivity: '2025-09-03T14:30:00Z',
    photo: '/src/assets/client-marcus.jpg',
    services: {
      daily: { date: getTodayDate(), metro: 0, laundry: 0, meal: 1, juice: 1 },
      total: { date: getTodayDate(), metro: 8, laundry: 3, meal: 19, juice: 15 }
    }
  },
  {
    id: CLIENT_IDS.c8,
    name: 'Steven R. Garcia',
    age: 43,
    room: '401B',
    room_id: DEMO_IDS.rooms.r401,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-in',
    caseWorker: 'Sandra Lopez',
    phone: '(555) 890-1234',
    alerts: ['Received Transit', '2 Lunch'],
    checkInTime: '2025-09-04T08:00:00Z',
    lastActivity: '2025-09-04T11:45:00Z',
    photo: '/src/assets/client-steven.jpg',
    services: {
      daily: { date: getTodayDate(), metro: 1, laundry: 0, meal: 1, juice: 0 },
      total: { date: getTodayDate(), metro: 19, laundry: 11, meal: 43, juice: 29 }
    }
  },
  {
    id: 'd0000000-0000-0000-0000-000000000009',
    name: 'William P. Harris',
    age: 37,
    room: '103B',
    room_id: DEMO_IDS.rooms.r103,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-in',
    caseWorker: 'Sarah Johnson',
    phone: '(555) 901-2345',
    alerts: ['ILP Reminder'],
    checkInTime: '2025-09-04T07:45:00Z',
    lastActivity: '2025-09-04T09:00:00Z',
    services: {
      daily: { date: getTodayDate(), metro: 1, laundry: 0, meal: 2, juice: 1 },
      total: { date: getTodayDate(), metro: 15, laundry: 4, meal: 36, juice: 20 }
    }
  },
  {
    id: 'd0000000-0000-0000-0000-000000000010',
    name: 'Raymond K. Clark',
    age: 48,
    room: '104A',
    room_id: DEMO_IDS.rooms.r104,
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    siteName: 'Sleep Out',
    status: 'checked-in',
    caseWorker: 'Jennifer Davis',
    phone: '(555) 012-3456',
    alerts: ['Received Transit'],
    checkInTime: '2025-09-04T08:15:00Z',
    lastActivity: '2025-09-04T10:30:00Z',
    services: {
      daily: { date: getTodayDate(), metro: 1, laundry: 0, meal: 1, juice: 0 },
      total: { date: getTodayDate(), metro: 21, laundry: 7, meal: 52, juice: 18 }
    }
  }
];

// Alert UUIDs
const ALERT_IDS = {
  a1: 'e0000000-0000-0000-0000-000000000001',
  a2: 'e0000000-0000-0000-0000-000000000002',
  a3: 'e0000000-0000-0000-0000-000000000003',
  a4: 'e0000000-0000-0000-0000-000000000004',
  a5: 'e0000000-0000-0000-0000-000000000005',
  a6: 'e0000000-0000-0000-0000-000000000006',
};

export const mockAlerts: Alert[] = [
  {
    id: ALERT_IDS.a1,
    type: 'critical',
    title: 'System Security Alert',
    description: 'Unauthorized access attempt detected in admin panel',
    timestamp: '2024-01-15 14:30:00',
    status: 'active',
    createdBy: 'System',
    category: 'system'
  },
  {
    id: ALERT_IDS.a2,
    type: 'warning',
    title: 'Capacity Warning',
    description: 'Shelter capacity at 95% - consider overflow procedures',
    timestamp: '2024-01-15 13:45:00',
    status: 'active',
    createdBy: 'System',
    acknowledgedBy: 'Administrator',
    category: 'building'
  },
  {
    id: ALERT_IDS.a3,
    type: 'info',
    title: 'System Update',
    description: 'Scheduled maintenance window: Tonight 2:00 AM - 4:00 AM',
    timestamp: '2024-01-15 12:00:00',
    status: 'active',
    createdBy: 'System',
    category: 'system'
  },
  {
    id: ALERT_IDS.a4,
    type: 'warning',
    title: 'HVAC System Issue',
    description: 'Air conditioning unit in building section B needs maintenance',
    timestamp: '2024-01-15 15:15:00',
    status: 'active',
    createdBy: 'Maintenance Staff',
    category: 'building'
  },
  {
    id: ALERT_IDS.a5,
    type: 'info',
    title: 'Staff Training Reminder',
    description: 'Monthly safety training scheduled for all staff members',
    timestamp: '2024-01-15 13:30:00',
    status: 'active',
    createdBy: 'HR Department',
    category: 'staff'
  },
  {
    id: ALERT_IDS.a6,
    type: 'critical',
    title: 'Emergency Contact Update',
    description: 'Staff emergency contact information needs immediate review',
    timestamp: '2024-01-15 12:45:00',
    status: 'active',
    createdBy: 'Administration',
    category: 'staff'
  }
];

export const caseWorkers = [
  'Sarah Johnson',
  'Michael Chen',
  'Jennifer Davis',
  'Lisa Rodriguez',
  'Maria Gonzalez',
  'Dr. Patricia Williams',
  'James Mitchell',
  'Sandra Lopez'
];

// Mock sites/facilities
export const mockSites = [
  {
    id: DEMO_IDS.sites.sleepOut,
    name: 'Sleep Out',
    address: '123 Main St, Brooklyn, NY',
    phone: '(718) 555-0100',
    capacity: 50,
    is_active: true,
    current_occupancy: 42,
    room_total: 25
  },
  {
    id: DEMO_IDS.sites.bedstuty,
    name: 'Bedstuy Hotel',
    address: '456 Brooklyn Ave, Brooklyn, NY',
    phone: '(718) 555-0200',
    capacity: 75,
    is_active: true,
    current_occupancy: 68,
    room_total: 40
  },
  {
    id: DEMO_IDS.sites.friendsFamily,
    name: 'Friends & Family',
    address: '789 Park Pl, Brooklyn, NY',
    phone: '(718) 555-0300',
    capacity: 30,
    is_active: true,
    is_family_shelter: true,
    current_occupancy: 25,
    room_total: 15
  },
  {
    id: DEMO_IDS.sites.bre,
    name: 'BRE',
    address: '321 Center St, Brooklyn, NY',
    phone: '(718) 555-0400',
    capacity: 100,
    is_active: true,
    current_occupancy: 87,
    room_total: 50
  }
];

// Site client UUIDs
const SITE_CLIENT_IDS = {
  // Site 1 clients
  c1_1: 'f0000000-0000-0000-0001-000000000001',
  c1_2: 'f0000000-0000-0000-0001-000000000002',
  c1_3: 'f0000000-0000-0000-0001-000000000003',
  c1_4: 'f0000000-0000-0000-0001-000000000004',
  c1_5: 'f0000000-0000-0000-0001-000000000005',
  c1_6: 'f0000000-0000-0000-0001-000000000006',
  c1_7: 'f0000000-0000-0000-0001-000000000007',
  c1_8: 'f0000000-0000-0000-0001-000000000008',
  // Site 2 clients
  c2_1: 'f0000000-0000-0000-0002-000000000001',
  c2_2: 'f0000000-0000-0000-0002-000000000002',
  c2_3: 'f0000000-0000-0000-0002-000000000003',
  c2_4: 'f0000000-0000-0000-0002-000000000004',
  c2_5: 'f0000000-0000-0000-0002-000000000005',
  c2_6: 'f0000000-0000-0000-0002-000000000006',
  c2_7: 'f0000000-0000-0000-0002-000000000007',
  c2_8: 'f0000000-0000-0000-0002-000000000008',
  c2_9: 'f0000000-0000-0000-0002-000000000009',
  c2_10: 'f0000000-0000-0000-0002-000000000010',
  // Site 3 clients
  c3_1: 'f0000000-0000-0000-0003-000000000001',
  c3_2: 'f0000000-0000-0000-0003-000000000002',
  c3_3: 'f0000000-0000-0000-0003-000000000003',
  c3_4: 'f0000000-0000-0000-0003-000000000004',
  c3_5: 'f0000000-0000-0000-0003-000000000005',
  c3_6: 'f0000000-0000-0000-0003-000000000006',
  // Site 4 clients
  c4_1: 'f0000000-0000-0000-0004-000000000001',
  c4_2: 'f0000000-0000-0000-0004-000000000002',
  c4_3: 'f0000000-0000-0000-0004-000000000003',
  c4_4: 'f0000000-0000-0000-0004-000000000004',
  c4_5: 'f0000000-0000-0000-0004-000000000005',
  c4_6: 'f0000000-0000-0000-0004-000000000006',
  c4_7: 'f0000000-0000-0000-0004-000000000007',
  c4_8: 'f0000000-0000-0000-0004-000000000008',
  c4_9: 'f0000000-0000-0000-0004-000000000009',
  c4_10: 'f0000000-0000-0000-0004-000000000010',
  c4_11: 'f0000000-0000-0000-0004-000000000011',
  c4_12: 'f0000000-0000-0000-0004-000000000012',
};

// Mock clients for different sites
export const mockSiteClients = {
  [DEMO_IDS.sites.sleepOut]: [
    { id: SITE_CLIENT_IDS.c1_1, first_name: 'James', last_name: 'Wilson', name: 'James Wilson', age: 32, room: '101', status: 'checked-in', caseWorker: 'Sarah Johnson', photo: johnPhoto, site: 'Sleep Out', site_id: DEMO_IDS.sites.sleepOut, check_in_time: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c1_2, first_name: 'Maria', last_name: 'Lopez', name: 'Maria Lopez', age: 28, room: '102', status: 'checked-in', caseWorker: 'Michael Chen', photo: michaelPhoto, site: 'Sleep Out', site_id: DEMO_IDS.sites.sleepOut, check_in_time: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c1_3, first_name: 'Robert', last_name: 'Chen', name: 'Robert Chen', age: 45, room: '103', status: 'checked-out', caseWorker: 'Jennifer Davis', photo: robertPhoto, site: 'Sleep Out', site_id: DEMO_IDS.sites.sleepOut, check_in_time: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(), check_out_time: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c1_4, first_name: 'Angela', last_name: 'Martinez', name: 'Angela Martinez', age: 36, room: '104', status: 'checked-in', caseWorker: 'Lisa Rodriguez', site: 'Sleep Out', site_id: DEMO_IDS.sites.sleepOut, check_in_time: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c1_5, first_name: 'Daniel', last_name: 'Park', name: 'Daniel Park', age: 41, room: '105', status: 'checked-in', caseWorker: 'Maria Gonzalez', site: 'Sleep Out', site_id: DEMO_IDS.sites.sleepOut, check_in_time: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c1_6, first_name: 'Sarah', last_name: 'Thompson', name: 'Sarah Thompson', age: 29, room: '106', status: 'checked-out', caseWorker: 'Dr. Patricia Williams', site: 'Sleep Out', site_id: DEMO_IDS.sites.sleepOut, check_in_time: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString(), check_out_time: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c1_7, first_name: 'Michael', last_name: 'Rodriguez', name: 'Michael Rodriguez', age: 38, room: '107', status: 'checked-in', caseWorker: 'James Mitchell', site: 'Sleep Out', site_id: DEMO_IDS.sites.sleepOut, check_in_time: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c1_8, first_name: 'Lisa', last_name: 'Anderson', name: 'Lisa Anderson', age: 33, room: '108', status: 'checked-in', caseWorker: 'Sandra Lopez', site: 'Sleep Out', site_id: DEMO_IDS.sites.sleepOut, check_in_time: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString() },
  ],
  [DEMO_IDS.sites.bedstuty]: [
    { id: SITE_CLIENT_IDS.c2_1, first_name: 'Patricia', last_name: 'Moore', name: 'Patricia Moore', age: 38, room: '201', status: 'checked-in', caseWorker: 'Lisa Rodriguez', photo: davidPhoto, site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 22 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 22 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_2, first_name: 'Kevin', last_name: 'Brown', name: 'Kevin Brown', age: 41, room: '202', status: 'checked-in', caseWorker: 'Maria Gonzalez', photo: carlosPhoto, site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 16 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 16 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_3, first_name: 'Linda', last_name: 'Martinez', name: 'Linda Martinez', age: 35, room: '203', status: 'checked-in', caseWorker: 'Dr. Patricia Williams', photo: anthonyPhoto, site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_4, first_name: 'Gregory', last_name: 'Taylor', name: 'Gregory Taylor', age: 44, room: '204', status: 'checked-out', caseWorker: 'James Mitchell', site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(), check_out_time: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_5, first_name: 'Nicole', last_name: 'Garcia', name: 'Nicole Garcia', age: 31, room: '205', status: 'checked-in', caseWorker: 'Sandra Lopez', site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_6, first_name: 'Raymond', last_name: 'White', name: 'Raymond White', age: 47, room: '206', status: 'checked-in', caseWorker: 'Sarah Johnson', site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 19 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 19 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_7, first_name: 'Deborah', last_name: 'Lee', name: 'Deborah Lee', age: 34, room: '207', status: 'checked-in', caseWorker: 'Michael Chen', site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_8, first_name: 'Frank', last_name: 'Harris', name: 'Frank Harris', age: 39, room: '208', status: 'checked-out', caseWorker: 'Jennifer Davis', site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 27 * 24 * 60 * 60 * 1000).toISOString(), check_out_time: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 27 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_9, first_name: 'Carol', last_name: 'Wilson', name: 'Carol Wilson', age: 42, room: '209', status: 'checked-in', caseWorker: 'Lisa Rodriguez', site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c2_10, first_name: 'George', last_name: 'Clark', name: 'George Clark', age: 36, room: '210', status: 'checked-in', caseWorker: 'Maria Gonzalez', site: 'Bedstuy Hotel', site_id: DEMO_IDS.sites.bedstuty, check_in_time: new Date(Date.now() - 13 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 13 * 24 * 60 * 60 * 1000).toISOString() },
  ],
  [DEMO_IDS.sites.friendsFamily]: [
    { id: SITE_CLIENT_IDS.c3_1, first_name: 'Thomas', last_name: 'Anderson', name: 'Thomas Anderson', age: 29, room: '301', status: 'checked-in', caseWorker: 'James Mitchell', photo: marcusPhoto, site: 'Friends & Family', site_id: DEMO_IDS.sites.friendsFamily, check_in_time: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(), isHeadOfHousehold: true, partnerName: 'Maria Anderson', children: [{ name: 'Emily Anderson', age: 7 }, { name: 'Jacob Anderson', age: 4 }] },
    { id: SITE_CLIENT_IDS.c3_2, first_name: 'Susan', last_name: 'Taylor', name: 'Susan Taylor', age: 33, room: '302', status: 'checked-out', caseWorker: 'Sandra Lopez', photo: stevenPhoto, site: 'Friends & Family', site_id: DEMO_IDS.sites.friendsFamily, check_in_time: new Date(Date.now() - 26 * 24 * 60 * 60 * 1000).toISOString(), check_out_time: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 26 * 24 * 60 * 60 * 1000).toISOString(), isHeadOfHousehold: true, children: [{ name: 'Sophia Taylor', age: 10 }] },
    { id: SITE_CLIENT_IDS.c3_3, first_name: 'William', last_name: 'Davis', name: 'William Davis', age: 47, room: '303', status: 'checked-in', caseWorker: 'Sarah Johnson', site: 'Friends & Family', site_id: DEMO_IDS.sites.friendsFamily, check_in_time: new Date(Date.now() - 17 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 17 * 24 * 60 * 60 * 1000).toISOString(), isHeadOfHousehold: true, partnerName: 'Linda Davis', children: [{ name: 'Michael Davis', age: 12 }, { name: 'Sarah Davis', age: 9 }, { name: 'James Davis', age: 5 }] },
    { id: SITE_CLIENT_IDS.c3_4, first_name: 'Barbara', last_name: 'Martinez', name: 'Barbara Martinez', age: 40, room: '304', status: 'checked-in', caseWorker: 'Michael Chen', site: 'Friends & Family', site_id: DEMO_IDS.sites.friendsFamily, check_in_time: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000).toISOString(), isHeadOfHousehold: true, partnerName: 'Carlos Martinez', children: [{ name: 'Isabella Martinez', age: 6 }] },
    { id: SITE_CLIENT_IDS.c3_5, first_name: 'Richard', last_name: 'Thompson', name: 'Richard Thompson', age: 35, room: '305', status: 'checked-out', caseWorker: 'Jennifer Davis', site: 'Friends & Family', site_id: DEMO_IDS.sites.friendsFamily, check_in_time: new Date(Date.now() - 29 * 24 * 60 * 60 * 1000).toISOString(), check_out_time: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 29 * 24 * 60 * 60 * 1000).toISOString(), isHeadOfHousehold: true, partnerName: 'Jessica Thompson', children: [{ name: 'Ethan Thompson', age: 8 }, { name: 'Olivia Thompson', age: 3 }] },
    { id: SITE_CLIENT_IDS.c3_6, first_name: 'Elizabeth', last_name: 'Brown', name: 'Elizabeth Brown', age: 28, room: '306', status: 'checked-in', caseWorker: 'Lisa Rodriguez', site: 'Friends & Family', site_id: DEMO_IDS.sites.friendsFamily, check_in_time: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(), isHeadOfHousehold: true, children: [{ name: 'Aiden Brown', age: 2 }] },
  ],
  [DEMO_IDS.sites.bre]: [
    { id: SITE_CLIENT_IDS.c4_1, first_name: 'Jennifer', last_name: 'White', name: 'Jennifer White', age: 36, room: '401', status: 'checked-in', caseWorker: 'Michael Chen', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 23 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 23 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_2, first_name: 'Christopher', last_name: 'Lee', name: 'Christopher Lee', age: 42, room: '402', status: 'checked-in', caseWorker: 'Jennifer Davis', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_3, first_name: 'Nancy', last_name: 'Harris', name: 'Nancy Harris', age: 31, room: '403', status: 'checked-in', caseWorker: 'Lisa Rodriguez', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_4, first_name: 'Joshua', last_name: 'Young', name: 'Joshua Young', age: 38, room: '404', status: 'checked-out', caseWorker: 'Maria Gonzalez', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString(), check_out_time: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_5, first_name: 'Amanda', last_name: 'King', name: 'Amanda King', age: 34, room: '405', status: 'checked-in', caseWorker: 'Dr. Patricia Williams', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_6, first_name: 'Donald', last_name: 'Wright', name: 'Donald Wright', age: 45, room: '406', status: 'checked-in', caseWorker: 'James Mitchell', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_7, first_name: 'Sandra', last_name: 'Scott', name: 'Sandra Scott', age: 37, room: '407', status: 'checked-in', caseWorker: 'Sandra Lopez', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_8, first_name: 'Paul', last_name: 'Green', name: 'Paul Green', age: 33, room: '408', status: 'checked-out', caseWorker: 'Sarah Johnson', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(), check_out_time: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_9, first_name: 'Dorothy', last_name: 'Adams', name: 'Dorothy Adams', age: 41, room: '409', status: 'checked-in', caseWorker: 'Michael Chen', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_10, first_name: 'Mark', last_name: 'Baker', name: 'Mark Baker', age: 39, room: '410', status: 'checked-in', caseWorker: 'Jennifer Davis', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_11, first_name: 'Betty', last_name: 'Nelson', name: 'Betty Nelson', age: 30, room: '411', status: 'checked-in', caseWorker: 'Lisa Rodriguez', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 16 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 16 * 24 * 60 * 60 * 1000).toISOString() },
    { id: SITE_CLIENT_IDS.c4_12, first_name: 'Kenneth', last_name: 'Carter', name: 'Kenneth Carter', age: 46, room: '412', status: 'checked-in', caseWorker: 'Maria Gonzalez', site: 'BRE', site_id: DEMO_IDS.sites.bre, check_in_time: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000).toISOString(), created_at: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000).toISOString() },
  ]
};
// Service log UUIDs  
const SERVICE_LOG_IDS = {
  sl1: 'g0000000-0000-0000-0000-000000000001',
  sl2: 'g0000000-0000-0000-0000-000000000002',
  sl3: 'g0000000-0000-0000-0000-000000000003',
  sl4: 'g0000000-0000-0000-0000-000000000004',
  sl5: 'g0000000-0000-0000-0000-000000000005',
  sl6: 'g0000000-0000-0000-0000-000000000006',
  sl7: 'g0000000-0000-0000-0000-000000000007',
  sl8: 'g0000000-0000-0000-0000-000000000008',
  sl9: 'g0000000-0000-0000-0000-000000000009',
  sl10: 'g0000000-0000-0000-0000-000000000010',
  sl11: 'g0000000-0000-0000-0000-000000000011',
  sl12: 'g0000000-0000-0000-0000-000000000012',
  sl13: 'g0000000-0000-0000-0000-000000000013',
  sl14: 'g0000000-0000-0000-0000-000000000014',
  sl15: 'g0000000-0000-0000-0000-000000000015',
  sl16: 'g0000000-0000-0000-0000-000000000016',
  sl17: 'g0000000-0000-0000-0000-000000000017',
  sl18: 'g0000000-0000-0000-0000-000000000018',
  sl19: 'g0000000-0000-0000-0000-000000000019',
  sl20: 'g0000000-0000-0000-0000-000000000020',
  sl21: 'g0000000-0000-0000-0000-000000000021',
  sl22: 'g0000000-0000-0000-0000-000000000022',
  sl23: 'g0000000-0000-0000-0000-000000000023',
  sl24: 'g0000000-0000-0000-0000-000000000024',
  sl25: 'g0000000-0000-0000-0000-000000000025',
  sl26: 'g0000000-0000-0000-0000-000000000026',
  sl27: 'g0000000-0000-0000-0000-000000000027',
  sl28: 'g0000000-0000-0000-0000-000000000028',
  sl29: 'g0000000-0000-0000-0000-000000000029',
  sl30: 'g0000000-0000-0000-0000-000000000030',
  sl31: 'g0000000-0000-0000-0000-000000000031',
  sl32: 'g0000000-0000-0000-0000-000000000032',
  sl33: 'g0000000-0000-0000-0000-000000000033',
};

// Mock service logs for demo
// TODAY's service logs (these sync with ServicesSummaryCard "Today's Services")
const todayISO = new Date().toISOString();
export const mockTodayServiceLogs = [
  { id: 'g0000000-0000-0000-0000-000000000100', client_id: SITE_CLIENT_IDS.c1_1, service_type: 'metro' as const, quantity: 2, created_at: todayISO, site_id: DEMO_IDS.sites.sleepOut },
  { id: 'g0000000-0000-0000-0000-000000000101', client_id: SITE_CLIENT_IDS.c1_2, service_type: 'meal' as const, quantity: 3, created_at: todayISO, site_id: DEMO_IDS.sites.sleepOut },
  { id: 'g0000000-0000-0000-0000-000000000102', client_id: SITE_CLIENT_IDS.c2_1, service_type: 'laundry' as const, quantity: 2, created_at: todayISO, site_id: DEMO_IDS.sites.bedstuty },
  { id: 'g0000000-0000-0000-0000-000000000103', client_id: SITE_CLIENT_IDS.c2_2, service_type: 'juice' as const, quantity: 4, created_at: todayISO, site_id: DEMO_IDS.sites.bedstuty },
  { id: 'g0000000-0000-0000-0000-000000000104', client_id: SITE_CLIENT_IDS.c3_1, service_type: 'meal' as const, quantity: 5, created_at: todayISO, site_id: DEMO_IDS.sites.friendsFamily },
  { id: 'g0000000-0000-0000-0000-000000000105', client_id: SITE_CLIENT_IDS.c3_3, service_type: 'metro' as const, quantity: 1, created_at: todayISO, site_id: DEMO_IDS.sites.friendsFamily },
  { id: 'g0000000-0000-0000-0000-000000000106', client_id: SITE_CLIENT_IDS.c4_1, service_type: 'juice' as const, quantity: 3, created_at: todayISO, site_id: DEMO_IDS.sites.bre },
  { id: 'g0000000-0000-0000-0000-000000000107', client_id: SITE_CLIENT_IDS.c4_2, service_type: 'meal' as const, quantity: 4, created_at: todayISO, site_id: DEMO_IDS.sites.bre },
  { id: 'g0000000-0000-0000-0000-000000000108', client_id: SITE_CLIENT_IDS.c1_4, service_type: 'laundry' as const, quantity: 1, created_at: todayISO, site_id: DEMO_IDS.sites.sleepOut },
  { id: 'g0000000-0000-0000-0000-000000000109', client_id: SITE_CLIENT_IDS.c4_3, service_type: 'metro' as const, quantity: 2, created_at: todayISO, site_id: DEMO_IDS.sites.bre },
];

export const mockServiceLogs = [
  // Include today's logs so they show everywhere
  ...mockTodayServiceLogs,
  // Last 30 days of service logs with varied dates and quantities
  { id: SERVICE_LOG_IDS.sl1, client_id: SITE_CLIENT_IDS.c1_1, service_type: 'metro' as const, quantity: 2, created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl2, client_id: SITE_CLIENT_IDS.c1_2, service_type: 'meal' as const, quantity: 3, created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl3, client_id: SITE_CLIENT_IDS.c1_3, service_type: 'laundry' as const, quantity: 1, created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl4, client_id: SITE_CLIENT_IDS.c2_1, service_type: 'juice' as const, quantity: 5, created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl5, client_id: SITE_CLIENT_IDS.c2_2, service_type: 'metro' as const, quantity: 1, created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl6, client_id: SITE_CLIENT_IDS.c3_1, service_type: 'meal' as const, quantity: 4, created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.friendsFamily },
  { id: SERVICE_LOG_IDS.sl7, client_id: SITE_CLIENT_IDS.c3_2, service_type: 'laundry' as const, quantity: 2, created_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.friendsFamily },
  { id: SERVICE_LOG_IDS.sl8, client_id: SITE_CLIENT_IDS.c4_1, service_type: 'metro' as const, quantity: 3, created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bre },
  { id: SERVICE_LOG_IDS.sl9, client_id: SITE_CLIENT_IDS.c4_2, service_type: 'meal' as const, quantity: 6, created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bre },
  { id: SERVICE_LOG_IDS.sl10, client_id: SITE_CLIENT_IDS.c1_4, service_type: 'juice' as const, quantity: 4, created_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl11, client_id: SITE_CLIENT_IDS.c1_5, service_type: 'laundry' as const, quantity: 1, created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl12, client_id: SITE_CLIENT_IDS.c2_3, service_type: 'metro' as const, quantity: 2, created_at: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl13, client_id: SITE_CLIENT_IDS.c2_4, service_type: 'meal' as const, quantity: 5, created_at: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl14, client_id: SITE_CLIENT_IDS.c3_3, service_type: 'juice' as const, quantity: 3, created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.friendsFamily },
  { id: SERVICE_LOG_IDS.sl15, client_id: SITE_CLIENT_IDS.c4_3, service_type: 'laundry' as const, quantity: 2, created_at: new Date(Date.now() - 11 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bre },
  { id: SERVICE_LOG_IDS.sl16, client_id: SITE_CLIENT_IDS.c1_6, service_type: 'metro' as const, quantity: 1, created_at: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl17, client_id: SITE_CLIENT_IDS.c2_5, service_type: 'meal' as const, quantity: 4, created_at: new Date(Date.now() - 13 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl18, client_id: SITE_CLIENT_IDS.c3_4, service_type: 'juice' as const, quantity: 6, created_at: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.friendsFamily },
  { id: SERVICE_LOG_IDS.sl19, client_id: SITE_CLIENT_IDS.c4_4, service_type: 'laundry' as const, quantity: 1, created_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bre },
  { id: SERVICE_LOG_IDS.sl20, client_id: SITE_CLIENT_IDS.c1_7, service_type: 'metro' as const, quantity: 2, created_at: new Date(Date.now() - 16 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl21, client_id: SITE_CLIENT_IDS.c2_6, service_type: 'meal' as const, quantity: 7, created_at: new Date(Date.now() - 17 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl22, client_id: SITE_CLIENT_IDS.c3_5, service_type: 'juice' as const, quantity: 3, created_at: new Date(Date.now() - 18 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.friendsFamily },
  { id: SERVICE_LOG_IDS.sl23, client_id: SITE_CLIENT_IDS.c4_5, service_type: 'laundry' as const, quantity: 2, created_at: new Date(Date.now() - 19 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bre },
  { id: SERVICE_LOG_IDS.sl24, client_id: SITE_CLIENT_IDS.c1_8, service_type: 'metro' as const, quantity: 3, created_at: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl25, client_id: SITE_CLIENT_IDS.c2_7, service_type: 'meal' as const, quantity: 5, created_at: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl26, client_id: SITE_CLIENT_IDS.c3_6, service_type: 'juice' as const, quantity: 4, created_at: new Date(Date.now() - 22 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.friendsFamily },
  { id: SERVICE_LOG_IDS.sl27, client_id: SITE_CLIENT_IDS.c4_6, service_type: 'laundry' as const, quantity: 1, created_at: new Date(Date.now() - 23 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bre },
  { id: SERVICE_LOG_IDS.sl28, client_id: SITE_CLIENT_IDS.c1_1, service_type: 'metro' as const, quantity: 2, created_at: new Date(Date.now() - 24 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl29, client_id: SITE_CLIENT_IDS.c2_8, service_type: 'meal' as const, quantity: 6, created_at: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl30, client_id: SITE_CLIENT_IDS.c4_7, service_type: 'juice' as const, quantity: 5, created_at: new Date(Date.now() - 26 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bre },
  { id: SERVICE_LOG_IDS.sl31, client_id: SITE_CLIENT_IDS.c1_2, service_type: 'laundry' as const, quantity: 2, created_at: new Date(Date.now() - 27 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.sleepOut },
  { id: SERVICE_LOG_IDS.sl32, client_id: SITE_CLIENT_IDS.c2_9, service_type: 'metro' as const, quantity: 1, created_at: new Date(Date.now() - 28 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bedstuty },
  { id: SERVICE_LOG_IDS.sl33, client_id: SITE_CLIENT_IDS.c4_8, service_type: 'meal' as const, quantity: 4, created_at: new Date(Date.now() - 29 * 24 * 60 * 60 * 1000).toISOString(), site_id: DEMO_IDS.sites.bre },
];

// Staff UUIDs
const STAFF_IDS = {
  s1: 'h0000000-0000-0000-0000-000000000001',
  s2: 'h0000000-0000-0000-0000-000000000002',
  s3: 'h0000000-0000-0000-0000-000000000003',
  s4: 'h0000000-0000-0000-0000-000000000004',
  s5: 'h0000000-0000-0000-0000-000000000005',
  s6: 'h0000000-0000-0000-0000-000000000006',
  s7: 'h0000000-0000-0000-0000-000000000007',
  s8: 'h0000000-0000-0000-0000-000000000008',
  s9: 'h0000000-0000-0000-0000-000000000009',
  s10: 'h0000000-0000-0000-0000-000000000010',
};

// Mock staff for manager demo
export const mockStaff = [
  {
    id: STAFF_IDS.s1,
    username: 'sarah.johnson',
    full_name: 'Sarah Johnson',
    email: 'sarah.j@shelter.org',
    phone: '(555) 201-3001',
    position: 'Case Manager',
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    is_active: true,
    created_at: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-2',
    username: 'michael.chen',
    full_name: 'Michael Chen',
    email: 'michael.c@shelter.org',
    phone: '(555) 201-3002',
    position: 'Case Manager Supervisor',
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    is_active: true,
    created_at: new Date(Date.now() - 200 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-3',
    username: 'jennifer.davis',
    full_name: 'Jennifer Davis',
    email: 'jennifer.d@shelter.org',
    phone: '(555) 201-3003',
    position: 'Residential Aide',
    site_id: DEMO_IDS.sites.bedstuty,
    site_name: 'Bedstuy Hotel',
    is_active: true,
    created_at: new Date(Date.now() - 150 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-4',
    username: 'lisa.rodriguez',
    full_name: 'Lisa Rodriguez',
    email: 'lisa.r@shelter.org',
    phone: '(555) 201-3004',
    position: 'Case Manager',
    site_id: DEMO_IDS.sites.bedstuty,
    site_name: 'Bedstuy Hotel',
    is_active: true,
    created_at: new Date(Date.now() - 165 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-5',
    username: 'maria.gonzalez',
    full_name: 'Maria Gonzalez',
    email: 'maria.g@shelter.org',
    phone: '(555) 201-3005',
    position: 'Supervisor',
    site_id: DEMO_IDS.sites.friendsFamily,
    site_name: 'Friends & Family',
    is_active: true,
    created_at: new Date(Date.now() - 190 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-6',
    username: 'patricia.williams',
    full_name: 'Dr. Patricia Williams',
    email: 'patricia.w@shelter.org',
    phone: '(555) 201-3006',
    position: 'Operations Manager',
    site_id: DEMO_IDS.sites.bre,
    site_name: 'BRE',
    is_active: true,
    created_at: new Date(Date.now() - 220 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-7',
    username: 'james.mitchell',
    full_name: 'James Mitchell',
    email: 'james.m@shelter.org',
    phone: '(555) 201-3007',
    position: 'Residential Aide',
    site_id: DEMO_IDS.sites.friendsFamily,
    site_name: 'Friends & Family',
    is_active: true,
    created_at: new Date(Date.now() - 140 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-8',
    username: 'sandra.lopez',
    full_name: 'Sandra Lopez',
    email: 'sandra.l@shelter.org',
    phone: '(555) 201-3008',
    position: 'Case Manager',
    site_id: DEMO_IDS.sites.bre,
    site_name: 'BRE',
    is_active: true,
    created_at: new Date(Date.now() - 175 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-9',
    username: 'robert.taylor',
    full_name: 'Robert Taylor',
    email: 'robert.t@shelter.org',
    phone: '(555) 201-3009',
    position: 'Residential Aide',
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    is_active: true,
    created_at: new Date(Date.now() - 120 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-10',
    username: 'emily.anderson',
    full_name: 'Emily Anderson',
    email: 'emily.a@shelter.org',
    phone: '(555) 201-3010',
    position: 'Supervisor',
    site_id: DEMO_IDS.sites.bedstuty,
    site_name: 'Bedstuy Hotel',
    is_active: true,
    created_at: new Date(Date.now() - 160 * 24 * 60 * 60 * 1000).toISOString()
  },
  // Additional staff for Friends & Family (Family Shelter)
  {
    id: 'staff-11',
    username: 'angela.thompson',
    full_name: 'Angela Thompson',
    email: 'angela.t@shelter.org',
    phone: '(555) 201-3011',
    position: 'Family Case Manager',
    site_id: DEMO_IDS.sites.friendsFamily,
    site_name: 'Friends & Family',
    is_active: true,
    created_at: new Date(Date.now() - 130 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-12',
    username: 'david.wilson',
    full_name: 'David Wilson',
    email: 'david.w@shelter.org',
    phone: '(555) 201-3012',
    position: 'Childcare Coordinator',
    site_id: DEMO_IDS.sites.friendsFamily,
    site_name: 'Friends & Family',
    is_active: true,
    created_at: new Date(Date.now() - 95 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-13',
    username: 'karen.brown',
    full_name: 'Karen Brown',
    email: 'karen.b@shelter.org',
    phone: '(555) 201-3013',
    position: 'Residential Aide',
    site_id: DEMO_IDS.sites.friendsFamily,
    site_name: 'Friends & Family',
    is_active: true,
    created_at: new Date(Date.now() - 85 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-14',
    username: 'marcus.johnson',
    full_name: 'Marcus Johnson',
    email: 'marcus.j@shelter.org',
    phone: '(555) 201-3014',
    position: 'Night Shift Supervisor',
    site_id: DEMO_IDS.sites.friendsFamily,
    site_name: 'Friends & Family',
    is_active: true,
    created_at: new Date(Date.now() - 110 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-15',
    username: 'rachel.martinez',
    full_name: 'Rachel Martinez',
    email: 'rachel.m@shelter.org',
    phone: '(555) 201-3015',
    position: 'Family Support Specialist',
    site_id: DEMO_IDS.sites.friendsFamily,
    site_name: 'Friends & Family',
    is_active: true,
    created_at: new Date(Date.now() - 75 * 24 * 60 * 60 * 1000).toISOString()
  },
  // More staff for other sites
  {
    id: 'staff-16',
    username: 'thomas.lee',
    full_name: 'Thomas Lee',
    email: 'thomas.l@shelter.org',
    phone: '(555) 201-3016',
    position: 'Residential Aide',
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    is_active: true,
    created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-17',
    username: 'nancy.white',
    full_name: 'Nancy White',
    email: 'nancy.w@shelter.org',
    phone: '(555) 201-3017',
    position: 'Program Coordinator',
    site_id: DEMO_IDS.sites.bre,
    site_name: 'BRE',
    is_active: true,
    created_at: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-18',
    username: 'kevin.harris',
    full_name: 'Kevin Harris',
    email: 'kevin.h@shelter.org',
    phone: '(555) 201-3018',
    position: 'Maintenance Supervisor',
    site_id: DEMO_IDS.sites.bedstuty,
    site_name: 'Bedstuy Hotel',
    is_active: true,
    created_at: new Date(Date.now() - 200 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-19',
    username: 'stephanie.clark',
    full_name: 'Stephanie Clark',
    email: 'stephanie.c@shelter.org',
    phone: '(555) 201-3019',
    position: 'Intake Specialist',
    site_id: DEMO_IDS.sites.sleepOut,
    site_name: 'Sleep Out',
    is_active: false, // Inactive staff member
    created_at: new Date(Date.now() - 300 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'staff-20',
    username: 'brian.jackson',
    full_name: 'Brian Jackson',
    email: 'brian.j@shelter.org',
    phone: '(555) 201-3020',
    position: 'Security Officer',
    site_id: DEMO_IDS.sites.bre,
    site_name: 'BRE',
    is_active: true,
    created_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString()
  }
];

export const mockNotes = [
  {
    id: 'note-1',
    title: 'Staff Meeting - Weekly Update',
    content: 'Discussed capacity management and new intake procedures. Need to review HVAC maintenance schedule.',
    created_by: DEMO_IDS.users.manager,
    site_id: DEMO_IDS.sites.sleepOut,
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'note-2',
    title: 'Bedstuy Hotel - Capacity Planning',
    content: 'Approaching full capacity. Coordinating with overflow facilities.',
    created_by: DEMO_IDS.users.manager,
    site_id: DEMO_IDS.sites.bedstuty,
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'note-3',
    title: 'System Update - Training Required',
    content: 'New intake software deployed. All staff need to complete training by end of week.',
    created_by: DEMO_IDS.users.manager,
    site_id: null,
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    id: 'note-4',
    title: 'Progress Update - James Wilson',
    content: 'Spoke with @[Sarah Johnson](user:' + STAFF_IDS.s1 + ') regarding @[James Wilson](client:' + SITE_CLIENT_IDS.c1_1 + ') housing application. Sarah confirmed that James has completed all required documents and his voucher application has been submitted. Follow-up meeting scheduled for next week to review outcomes.',
    created_by: DEMO_IDS.users.manager,
    site_id: DEMO_IDS.sites.sleepOut,
    created_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    note_type: 'progress',
    is_private: false
  },
  {
    id: 'note-5',
    title: 'Incident Follow-Up - Patricia Moore',
    content: '@[Dr. Patricia Williams](user:staff-6) please review the medical report for @[Patricia Moore](client:' + SITE_CLIENT_IDS.c2_1 + '). Client reported feeling unwell after dinner and was seen by on-call nurse. @[Lisa Rodriguez](user:staff-4) documented the incident and contacted the emergency contact on file. No hospitalization required but follow-up recommended within 48 hours.',
    created_by: DEMO_IDS.users.supervisor,
    site_id: DEMO_IDS.sites.bedstuty,
    created_at: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    note_type: 'incident',
    is_private: false
  }
];

// Mock alerts for manager demo sites - distributed over last 30 days
export const mockSiteAlerts = [
  // Recent critical alerts
  {
    id: 'alert-1',
    type: 'critical',
    title: 'Bedstuy Hotel - At Capacity',
    description: 'Facility at 91% capacity. Overflow procedures activated.',
    created_at: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'building',
    site_id: DEMO_IDS.sites.bedstuty,
    created_by: '1'
  },
  {
    id: 'alert-2',
    type: 'critical',
    title: 'BRE - Emergency System Check Required',
    description: 'Fire alarm system needs immediate inspection.',
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'resolved',
    category: 'building',
    site_id: DEMO_IDS.sites.bre,
    created_by: '2'
  },
  // Warning alerts
  {
    id: 'alert-3',
    type: 'warning',
    title: 'Sleep Out - Near Capacity',
    description: 'Occupancy at 84%. Monitor for overflow procedures.',
    created_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'building',
    site_id: DEMO_IDS.sites.sleepOut,
    created_by: '1'
  },
  {
    id: 'alert-4',
    title: 'BRE - HVAC Maintenance Required',
    type: 'warning',
    description: 'Scheduled maintenance needed for cooling system.',
    created_at: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'building',
    site_id: DEMO_IDS.sites.bre,
    created_by: '2'
  },
  {
    id: 'alert-5',
    type: 'warning',
    title: 'Friends & Family - Supply Low',
    description: 'Kitchen supplies running low. Order needed.',
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'service',
    site_id: DEMO_IDS.sites.friendsFamily,
    created_by: '1'
  },
  {
    id: 'alert-6',
    type: 'warning',
    title: 'Sleep Out - Staffing Coverage',
    description: 'Need additional coverage for night shift this week.',
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'resolved',
    category: 'staff',
    site_id: DEMO_IDS.sites.sleepOut,
    created_by: '2'
  },
  {
    id: 'alert-7',
    type: 'warning',
    title: 'Bedstuy Hotel - Maintenance Request',
    description: 'Plumbing issue in Room 205 needs attention.',
    created_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'resolved',
    category: 'building',
    site_id: DEMO_IDS.sites.bedstuty,
    created_by: '1'
  },
  // Info alerts
  {
    id: 'alert-8',
    type: 'info',
    title: 'Friends & Family - Staff Training',
    description: 'New staff member orientation scheduled for tomorrow.',
    created_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'staff',
    site_id: DEMO_IDS.sites.friendsFamily,
    created_by: '2'
  },
  {
    id: 'alert-9',
    type: 'info',
    title: 'All Sites - Monthly Report Due',
    description: 'Monthly activity reports due by end of week.',
    created_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'system',
    site_id: null,
    created_by: '4'
  },
  {
    id: 'alert-10',
    type: 'info',
    title: 'BRE - Donation Received',
    description: 'Large clothing donation arrived, needs sorting.',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'service',
    site_id: DEMO_IDS.sites.bre,
    created_by: '1'
  },
  {
    id: 'alert-11',
    type: 'info',
    title: 'Sleep Out - Wellness Program',
    description: 'Weekly wellness session scheduled for Friday.',
    created_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'service',
    site_id: DEMO_IDS.sites.sleepOut,
    created_by: '2'
  },
  {
    id: 'alert-12',
    type: 'info',
    title: 'Bedstuy Hotel - Inspection Passed',
    description: 'Annual health inspection completed successfully.',
    created_at: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'resolved',
    category: 'system',
    site_id: DEMO_IDS.sites.bedstuty,
    created_by: '4'
  },
  {
    id: 'alert-13',
    type: 'info',
    title: 'Friends & Family - Community Event',
    description: 'Community outreach event planned for next month.',
    created_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'active',
    category: 'service',
    site_id: DEMO_IDS.sites.friendsFamily,
    created_by: '1'
  },
  {
    id: 'alert-14',
    type: 'info',
    title: 'All Sites - Software Update',
    description: 'System update scheduled for this weekend.',
    created_at: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
    status: 'resolved',
    category: 'system',
    site_id: null,
    created_by: '4'
  }
];

// Mock rosters for demo mode
// Helper to get name parts from full name string
const getNameParts = (fullName: string) => {
  const parts = fullName.split(' ');
  const firstName = parts[0];
  const lastName = parts.slice(1).join(' ');
  return { first_name: firstName, last_name: lastName };
};

export const mockRosters = [
  {
    id: 'roster-1',
    name: 'Sleep Out - Morning Roster',
    roster_date: new Date().toISOString().split('T')[0],
    site_id: DEMO_IDS.sites.sleepOut,
    shift_type: 'current',
    created_by: 'demo-manager',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    roster_entries: [
      { id: 're-1', client_id: 'c1-1', roster_id: 'roster-1', room_id: 'r-101', client: { ...getNameParts('James Wilson'), status: 'checked-in' }, room: { room_number: '101' } },
      { id: 're-2', client_id: 'c1-2', roster_id: 'roster-1', room_id: 'r-102', client: { ...getNameParts('Maria Lopez'), status: 'checked-in' }, room: { room_number: '102' } },
      { id: 're-3', client_id: 'c1-4', roster_id: 'roster-1', room_id: 'r-104', client: { ...getNameParts('Angela Martinez'), status: 'checked-in' }, room: { room_number: '104' } },
      { id: 're-4', client_id: 'c1-5', roster_id: 'roster-1', room_id: 'r-105', client: { ...getNameParts('Daniel Park'), status: 'checked-in' }, room: { room_number: '105' } },
      { id: 're-5', client_id: 'c1-7', roster_id: 'roster-1', room_id: 'r-107', client: { ...getNameParts('Michael Rodriguez'), status: 'checked-in' }, room: { room_number: '107' } },
      { id: 're-6', client_id: 'c1-8', roster_id: 'roster-1', room_id: 'r-108', client: { ...getNameParts('Lisa Anderson'), status: 'checked-in' }, room: { room_number: '108' } },
    ]
  },
  {
    id: 'roster-2',
    name: 'Bedstuy Hotel - Evening Roster',
    roster_date: new Date().toISOString().split('T')[0],
    site_id: DEMO_IDS.sites.bedstuty,
    shift_type: 'current',
    created_by: 'demo-manager',
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    roster_entries: [
      { id: 're-7', client_id: 'c2-1', roster_id: 'roster-2', room_id: 'r-201', client: { ...getNameParts('Patricia Moore'), status: 'checked-in' }, room: { room_number: '201' } },
      { id: 're-8', client_id: 'c2-2', roster_id: 'roster-2', room_id: 'r-202', client: { ...getNameParts('Kevin Brown'), status: 'checked-in' }, room: { room_number: '202' } },
      { id: 're-9', client_id: 'c2-3', roster_id: 'roster-2', room_id: 'r-203', client: { ...getNameParts('Linda Martinez'), status: 'checked-in' }, room: { room_number: '203' } },
      { id: 're-10', client_id: 'c2-5', roster_id: 'roster-2', room_id: 'r-205', client: { ...getNameParts('Nicole Garcia'), status: 'checked-in' }, room: { room_number: '205' } },
      { id: 're-11', client_id: 'c2-6', roster_id: 'roster-2', room_id: 'r-206', client: { ...getNameParts('Raymond White'), status: 'checked-in' }, room: { room_number: '206' } },
    ]
  },
  {
    id: 'roster-3',
    name: 'BRE - Night Shift',
    roster_date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    site_id: DEMO_IDS.sites.bre,
    shift_type: 'overnight',
    created_by: 'demo-manager',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    roster_entries: [
      { id: 're-12', client_id: 'c4-1', roster_id: 'roster-3', room_id: 'r-401', client: { ...getNameParts('Jennifer White'), status: 'checked-in' }, room: { room_number: '401' } },
      { id: 're-13', client_id: 'c4-2', roster_id: 'roster-3', room_id: 'r-402', client: { ...getNameParts('Christopher Lee'), status: 'checked-in' }, room: { room_number: '402' } },
      { id: 're-14', client_id: 'c4-3', roster_id: 'roster-3', room_id: 'r-403', client: { ...getNameParts('Nancy Harris'), status: 'checked-in' }, room: { room_number: '403' } },
      { id: 're-15', client_id: 'c4-5', roster_id: 'roster-3', room_id: 'r-405', client: { ...getNameParts('Amanda King'), status: 'checked-in' }, room: { room_number: '405' } },
    ]
  },
  {
    id: 'roster-4',
    name: 'Friends & Family - Evening Roster',
    roster_date: new Date().toISOString().split('T')[0],
    site_id: DEMO_IDS.sites.friendsFamily,
    shift_type: 'current',
    created_by: 'demo-manager',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    roster_entries: [
      { id: 're-16', client_id: 'c3-1', roster_id: 'roster-4', room_id: 'r-301', client: { ...getNameParts('Thomas Anderson'), status: 'checked-in', is_head_of_household: true, partner_id: 'c3-1-partner', children: [{ name: 'Emma Anderson', age: 8 }, { name: 'Jake Anderson', age: 5 }] }, room: { room_number: '301' } },
      { id: 're-17', client_id: 'c3-3', roster_id: 'roster-4', room_id: 'r-303', client: { ...getNameParts('William Davis'), status: 'checked-in', is_head_of_household: true, partner_id: null, children: [{ name: 'Lily Davis', age: 12 }, { name: 'Marcus Davis', age: 9 }, { name: 'Sophie Davis', age: 3 }] }, room: { room_number: '303' } },
      { id: 're-18', client_id: 'c3-4', roster_id: 'roster-4', room_id: 'r-304', client: { ...getNameParts('Barbara Martinez'), status: 'checked-in', is_head_of_household: true, partner_id: 'c3-4-partner', children: [{ name: 'Carlos Martinez', age: 14 }] }, room: { room_number: '304' } },
      { id: 're-19', client_id: 'c3-6', roster_id: 'roster-4', room_id: 'r-306', client: { ...getNameParts('Elizabeth Brown'), status: 'checked-in', is_head_of_household: true, partner_id: null, children: [{ name: 'Jayden Brown', age: 6 }, { name: 'Aaliyah Brown', age: 4 }] }, room: { room_number: '306' } },
    ]
  },
  {
    id: 'roster-5',
    name: 'Friends & Family - Morning Check',
    roster_date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    site_id: DEMO_IDS.sites.friendsFamily,
    shift_type: 'am',
    created_by: 'demo-manager',
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    roster_entries: [
      { id: 're-20', client_id: 'c3-1', roster_id: 'roster-5', room_id: 'r-301', client: { ...getNameParts('Thomas Anderson'), status: 'checked-in', is_head_of_household: true, partner_id: 'c3-1-partner', children: [{ name: 'Emma Anderson', age: 8 }, { name: 'Jake Anderson', age: 5 }] }, room: { room_number: '301' } },
      { id: 're-21', client_id: 'c3-2', roster_id: 'roster-5', room_id: 'r-302', client: { ...getNameParts('Susan Taylor'), status: 'checked-out', is_head_of_household: true, partner_id: 'c3-2-partner', children: [{ name: 'Mia Taylor', age: 10 }] }, room: { room_number: '302' } },
      { id: 're-22', client_id: 'c3-3', roster_id: 'roster-5', room_id: 'r-303', client: { ...getNameParts('William Davis'), status: 'checked-in', is_head_of_household: true, partner_id: null, children: [{ name: 'Lily Davis', age: 12 }, { name: 'Marcus Davis', age: 9 }, { name: 'Sophie Davis', age: 3 }] }, room: { room_number: '303' } },
      { id: 're-23', client_id: 'c3-4', roster_id: 'roster-5', room_id: 'r-304', client: { ...getNameParts('Barbara Martinez'), status: 'checked-in', is_head_of_household: true, partner_id: 'c3-4-partner', children: [{ name: 'Carlos Martinez', age: 14 }] }, room: { room_number: '304' } },
      { id: 're-24', client_id: 'c3-6', roster_id: 'roster-5', room_id: 'r-306', client: { ...getNameParts('Elizabeth Brown'), status: 'checked-in', is_head_of_household: true, partner_id: null, children: [{ name: 'Jayden Brown', age: 6 }, { name: 'Aaliyah Brown', age: 4 }] }, room: { room_number: '306' } },
    ]
  }
];

// Mock rooms for demo mode
export const mockRooms = [
  // Sleep Out rooms
  { id: 'r-101', room_number: '101', site_id: DEMO_IDS.sites.sleepOut, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-102', room_number: '102', site_id: DEMO_IDS.sites.sleepOut, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-103', room_number: '103', site_id: DEMO_IDS.sites.sleepOut, capacity: 2, current_occupancy: 0, is_occupied: false },
  { id: 'r-104', room_number: '104', site_id: DEMO_IDS.sites.sleepOut, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-105', room_number: '105', site_id: DEMO_IDS.sites.sleepOut, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-106', room_number: '106', site_id: DEMO_IDS.sites.sleepOut, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-107', room_number: '107', site_id: DEMO_IDS.sites.sleepOut, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-108', room_number: '108', site_id: DEMO_IDS.sites.sleepOut, capacity: 2, current_occupancy: 1, is_occupied: true },
  // Bedstuy Hotel rooms
  { id: 'r-201', room_number: '201', site_id: DEMO_IDS.sites.bedstuty, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-202', room_number: '202', site_id: DEMO_IDS.sites.bedstuty, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-203', room_number: '203', site_id: DEMO_IDS.sites.bedstuty, capacity: 2, current_occupancy: 1, is_occupied: true },
  { id: 'r-204', room_number: '204', site_id: DEMO_IDS.sites.bedstuty, capacity: 2, current_occupancy: 0, is_occupied: false },
  { id: 'r-205', room_number: '205', site_id: DEMO_IDS.sites.bedstuty, capacity: 2, current_occupancy: 1, is_occupied: true },
  // BRE rooms
  { id: 'r-401', room_number: '401', site_id: DEMO_IDS.sites.bre, capacity: 4, current_occupancy: 2, is_occupied: true },
  { id: 'r-402', room_number: '402', site_id: DEMO_IDS.sites.bre, capacity: 4, current_occupancy: 2, is_occupied: true },
  { id: 'r-403', room_number: '403', site_id: DEMO_IDS.sites.bre, capacity: 4, current_occupancy: 1, is_occupied: true },
  // Friends & Family rooms (Family Shelter - larger rooms for families)
  { id: 'r-301', room_number: '301', site_id: DEMO_IDS.sites.friendsFamily, capacity: 5, current_occupancy: 4, is_occupied: true },
  { id: 'r-302', room_number: '302', site_id: DEMO_IDS.sites.friendsFamily, capacity: 4, current_occupancy: 2, is_occupied: true },
  { id: 'r-303', room_number: '303', site_id: DEMO_IDS.sites.friendsFamily, capacity: 6, current_occupancy: 5, is_occupied: true },
  { id: 'r-304', room_number: '304', site_id: DEMO_IDS.sites.friendsFamily, capacity: 4, current_occupancy: 3, is_occupied: true },
  { id: 'r-305', room_number: '305', site_id: DEMO_IDS.sites.friendsFamily, capacity: 5, current_occupancy: 0, is_occupied: false },
  { id: 'r-306', room_number: '306', site_id: DEMO_IDS.sites.friendsFamily, capacity: 3, current_occupancy: 2, is_occupied: true },
];

// Mock Activity Logs for demo mode
export const mockActivityLogs = [
  {
    id: 'log-1',
    user_id: 'user-1',
    action_type: 'login',
    action_details: { method: 'password' },
    ip_address: '192.168.1.100',
    user_agent: 'Chrome/120.0',
    site_id: null,
    created_at: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    user_name: 'Sarah Administrator',
    site_name: null
  },
  {
    id: 'log-2',
    user_id: 'user-3',
    action_type: 'check_in',
    action_details: { client_name: 'Marcus Williams', room: '102' },
    ip_address: '192.168.1.105',
    user_agent: 'Firefox/121.0',
    site_id: DEMO_IDS.sites.sleepOut,
    created_at: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
    user_name: 'James Wilson',
    site_name: 'Sleep Out'
  },
  {
    id: 'log-3',
    user_id: 'user-4',
    action_type: 'create_alert',
    action_details: { type: 'warning', title: 'Medical attention needed' },
    ip_address: '192.168.1.110',
    user_agent: 'Safari/17.0',
    site_id: DEMO_IDS.sites.bedstuty,
    created_at: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    user_name: 'Maria Garcia',
    site_name: 'Bedstuy Hotel'
  },
  {
    id: 'log-4',
    user_id: 'user-5',
    action_type: 'update_client',
    action_details: { client_name: 'John Davis', field: 'status' },
    ip_address: '192.168.1.115',
    user_agent: 'Chrome/120.0',
    site_id: DEMO_IDS.sites.sleepOut,
    created_at: new Date(Date.now() - 45 * 60 * 1000).toISOString(),
    user_name: 'Robert Chen',
    site_name: 'Sleep Out'
  },
  {
    id: 'log-5',
    user_id: 'user-2',
    action_type: 'reset_password',
    action_details: { target_user: 'staff.member@shelter.org' },
    ip_address: '192.168.1.100',
    user_agent: 'Chrome/120.0',
    site_id: null,
    created_at: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
    user_name: 'Michael Thompson',
    site_name: null
  },
  {
    id: 'log-6',
    user_id: 'user-6',
    action_type: 'check_out',
    action_details: { client_name: 'David Brown', room: '205' },
    ip_address: '192.168.1.120',
    user_agent: 'Edge/120.0',
    site_id: DEMO_IDS.sites.friendsFamily,
    created_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    user_name: 'Jennifer Adams',
    site_name: 'Friends & Family'
  },
  {
    id: 'log-7',
    user_id: 'user-3',
    action_type: 'create_client',
    action_details: { client_name: 'Anthony Martinez' },
    ip_address: '192.168.1.105',
    user_agent: 'Firefox/121.0',
    site_id: DEMO_IDS.sites.sleepOut,
    created_at: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    user_name: 'James Wilson',
    site_name: 'Sleep Out'
  },
  {
    id: 'log-8',
    user_id: 'user-4',
    action_type: 'acknowledge_alert',
    action_details: { alert_title: 'Maintenance request' },
    ip_address: '192.168.1.110',
    user_agent: 'Safari/17.0',
    site_id: DEMO_IDS.sites.bedstuty,
    created_at: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
    user_name: 'Maria Garcia',
    site_name: 'Bedstuy Hotel'
  },
  {
    id: 'log-9',
    user_id: 'user-7',
    action_type: 'login',
    action_details: { method: 'password' },
    ip_address: '192.168.1.125',
    user_agent: 'Chrome/120.0',
    site_id: null,
    created_at: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    user_name: 'Kevin Williams',
    site_name: null
  },
  {
    id: 'log-10',
    user_id: 'user-5',
    action_type: 'logout',
    action_details: null,
    ip_address: '192.168.1.115',
    user_agent: 'Chrome/120.0',
    site_id: null,
    created_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    user_name: 'Robert Chen',
    site_name: null
  },
  {
    id: 'log-11',
    user_id: 'user-1',
    action_type: 'manage_access',
    action_details: { target_user: 'new.staff@shelter.org', action: 'grant_site_access' },
    ip_address: '192.168.1.100',
    user_agent: 'Chrome/120.0',
    site_id: DEMO_IDS.sites.bre,
    created_at: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    user_name: 'Sarah Administrator',
    site_name: 'BRE'
  },
  {
    id: 'log-12',
    user_id: 'user-8',
    action_type: 'check_in',
    action_details: { client_name: 'Steven Taylor', room: '301' },
    ip_address: '192.168.1.130',
    user_agent: 'Firefox/121.0',
    site_id: DEMO_IDS.sites.friendsFamily,
    created_at: new Date(Date.now() - 10 * 60 * 60 * 1000).toISOString(),
    user_name: 'Amanda Foster',
    site_name: 'Friends & Family'
  }
];

// Mock overdue trainings for demo mode
export const mockOverdueTrainings = [
  {
    staffName: 'Marcus Thompson',
    staffId: 'user-7',
    trainingTitle: 'Fire Safety Procedures',
    materialId: 'tm-1',
    dueDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    daysOverdue: 14,
  },
  {
    staffName: 'Angela Martinez',
    staffId: 'user-8',
    trainingTitle: 'De-escalation Techniques',
    materialId: 'tm-2',
    dueDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    daysOverdue: 7,
  },
  {
    staffName: 'Kevin Brown',
    staffId: 'user-9',
    trainingTitle: 'Client Intake Protocol',
    materialId: 'tm-3',
    dueDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    daysOverdue: 5,
  },
  {
    staffName: 'Jennifer Davis',
    staffId: 'user-5',
    trainingTitle: 'HIPAA Compliance',
    materialId: 'tm-4',
    dueDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    daysOverdue: 3,
  },
  {
    staffName: 'Emily Supervisor',
    staffId: 'user-11',
    trainingTitle: 'Emergency Response Training',
    materialId: 'tm-5',
    dueDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    daysOverdue: 2,
  },
];

// Mock users for User Management demo
// Composition: 1 Super Admin, 1 Manager, 2 Supervisors, 3 Case Managers, 3 Staff (Residential Aides) = 10 total
export const mockDemoUsers = [
  {
    id: 'user-1',
    email: 'admin@shelter.org',
    username: 'superadmin',
    full_name: 'Sarah Administrator',
    role: 'super_admin',
    created_at: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.sleepOut, DEMO_IDS.sites.bedstuty, DEMO_IDS.sites.friendsFamily, DEMO_IDS.sites.bre]
  },
  {
    id: 'user-3',
    email: 'manager@shelter.org',
    username: 'manager',
    full_name: 'Rachel Morrison',
    role: 'manager',
    created_at: new Date(Date.now() - 200 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.sleepOut, DEMO_IDS.sites.bedstuty, DEMO_IDS.sites.friendsFamily, DEMO_IDS.sites.bre]
  },
  {
    id: 'user-4',
    email: 'supervisor1@shelter.org',
    username: 'supervisor1',
    full_name: 'David Supervisor',
    role: 'supervisor',
    created_at: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.sleepOut, DEMO_IDS.sites.bedstuty]
  },
  {
    id: 'user-11',
    email: 'supervisor2@shelter.org',
    username: 'supervisor2',
    full_name: 'Emily Supervisor',
    role: 'supervisor',
    created_at: new Date(Date.now() - 160 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.friendsFamily, DEMO_IDS.sites.bre]
  },
  {
    id: 'user-5',
    email: 'case1@shelter.org',
    username: 'casemanager1',
    full_name: 'Jennifer Davis',
    role: 'case_manager',
    created_at: new Date(Date.now() - 150 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.sleepOut]
  },
  {
    id: 'user-6',
    email: 'case2@shelter.org',
    username: 'casemanager2',
    full_name: 'Lisa Rodriguez',
    role: 'case_manager',
    created_at: new Date(Date.now() - 120 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.bedstuty]
  },
  {
    id: 'user-12',
    email: 'case3@shelter.org',
    username: 'casemanager3',
    full_name: 'Sandra Lopez',
    role: 'case_manager',
    created_at: new Date(Date.now() - 100 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.friendsFamily, DEMO_IDS.sites.bre]
  },
  {
    id: 'user-7',
    email: 'aide1@shelter.org',
    username: 'resaide1',
    full_name: 'Marcus Thompson',
    role: 'residential_aide',
    created_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.sleepOut]
  },
  {
    id: 'user-8',
    email: 'aide2@shelter.org',
    username: 'resaide2',
    full_name: 'Angela Martinez',
    role: 'residential_aide',
    created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.bedstuty, DEMO_IDS.sites.friendsFamily]
  },
  {
    id: 'user-9',
    email: 'aide3@shelter.org',
    username: 'resaide3',
    full_name: 'Kevin Brown',
    role: 'residential_aide',
    created_at: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
    sites: [DEMO_IDS.sites.bre]
  }
];

// ============ INSPECTION DEMO DATA ============

const INSPECTION_IDS = {
  templates: {
    safety: 'e1000000-0000-0000-0000-000000000001',
    kitchen: 'e1000000-0000-0000-0000-000000000002',
    documentation: 'e1000000-0000-0000-0000-000000000003',
  },
  sections: {
    s1: 'e2000000-0000-0000-0000-000000000001',
    s2: 'e2000000-0000-0000-0000-000000000002',
    s3: 'e2000000-0000-0000-0000-000000000003',
    s4: 'e2000000-0000-0000-0000-000000000004',
    s5: 'e2000000-0000-0000-0000-000000000005',
    s6: 'e2000000-0000-0000-0000-000000000006',
  },
  items: {
    i1: 'e3000000-0000-0000-0000-000000000001',
    i2: 'e3000000-0000-0000-0000-000000000002',
    i3: 'e3000000-0000-0000-0000-000000000003',
    i4: 'e3000000-0000-0000-0000-000000000004',
    i5: 'e3000000-0000-0000-0000-000000000005',
    i6: 'e3000000-0000-0000-0000-000000000006',
    i7: 'e3000000-0000-0000-0000-000000000007',
    i8: 'e3000000-0000-0000-0000-000000000008',
    i9: 'e3000000-0000-0000-0000-000000000009',
    i10: 'e3000000-0000-0000-0000-000000000010',
    i11: 'e3000000-0000-0000-0000-000000000011',
    i12: 'e3000000-0000-0000-0000-000000000012',
  },
  inspections: {
    ins1: 'e4000000-0000-0000-0000-000000000001',
    ins2: 'e4000000-0000-0000-0000-000000000002',
    ins3: 'e4000000-0000-0000-0000-000000000003',
  },
};

export const mockInspectionTemplates = [
  {
    id: INSPECTION_IDS.templates.safety,
    name: 'Facility Safety & Compliance',
    description: 'Weekly safety walk-through for fire, electrical, and structural compliance',
    is_active: true,
    created_by: DEMO_IDS.users.manager,
    created_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: INSPECTION_IDS.templates.kitchen,
    name: 'Kitchen Health & Sanitation',
    description: 'Daily kitchen inspection for food safety and cleanliness standards',
    is_active: true,
    created_by: DEMO_IDS.users.manager,
    created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: INSPECTION_IDS.templates.documentation,
    name: 'Staff Documentation Review',
    description: 'Monthly review of staff certifications and training documentation',
    is_active: true,
    created_by: DEMO_IDS.users.manager,
    created_at: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

export const mockInspectionTemplateSections = [
  // Safety template sections
  { id: INSPECTION_IDS.sections.s1, template_id: INSPECTION_IDS.templates.safety, name: 'Fire Safety', subsection: null, sort_order: 0 },
  { id: INSPECTION_IDS.sections.s2, template_id: INSPECTION_IDS.templates.safety, name: 'Electrical & Structural', subsection: null, sort_order: 1 },
  // Kitchen template sections
  { id: INSPECTION_IDS.sections.s3, template_id: INSPECTION_IDS.templates.kitchen, name: 'Food Storage', subsection: null, sort_order: 0 },
  { id: INSPECTION_IDS.sections.s4, template_id: INSPECTION_IDS.templates.kitchen, name: 'Cleanliness', subsection: null, sort_order: 1 },
  // Documentation template sections
  { id: INSPECTION_IDS.sections.s5, template_id: INSPECTION_IDS.templates.documentation, name: 'Certifications', subsection: null, sort_order: 0 },
  { id: INSPECTION_IDS.sections.s6, template_id: INSPECTION_IDS.templates.documentation, name: 'Training Records', subsection: null, sort_order: 1 },
];

export const mockInspectionTemplateItems = [
  // Fire Safety items
  { id: INSPECTION_IDS.items.i1, section_id: INSPECTION_IDS.sections.s1, item_code: 'FS-01', item_text: 'Fire extinguishers present and charged', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: true, always_require_notes: false, sort_order: 0 },
  { id: INSPECTION_IDS.items.i2, section_id: INSPECTION_IDS.sections.s1, item_code: 'FS-02', item_text: 'Emergency exits clear and well-lit', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: false, always_require_notes: false, sort_order: 1 },
  // Electrical items
  { id: INSPECTION_IDS.items.i3, section_id: INSPECTION_IDS.sections.s2, item_code: 'ES-01', item_text: 'Electrical panels accessible and labeled', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: true, always_require_notes: false, sort_order: 0 },
  { id: INSPECTION_IDS.items.i4, section_id: INSPECTION_IDS.sections.s2, item_code: 'ES-02', item_text: 'No exposed wiring or tripping hazards', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: true, always_require_notes: false, sort_order: 1 },
  // Food Storage items
  { id: INSPECTION_IDS.items.i5, section_id: INSPECTION_IDS.sections.s3, item_code: 'KS-01', item_text: 'Refrigerator temperature below 40°F', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: false, always_require_notes: false, sort_order: 0 },
  { id: INSPECTION_IDS.items.i6, section_id: INSPECTION_IDS.sections.s3, item_code: 'KS-02', item_text: 'All food items properly labeled and dated', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: false, always_require_notes: false, sort_order: 1 },
  // Cleanliness items
  { id: INSPECTION_IDS.items.i7, section_id: INSPECTION_IDS.sections.s4, item_code: 'KC-01', item_text: 'Surfaces sanitized and clean', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: false, always_require_notes: false, sort_order: 0 },
  { id: INSPECTION_IDS.items.i8, section_id: INSPECTION_IDS.sections.s4, item_code: 'KC-02', item_text: 'Floors swept and mopped', response_type: 'PASS_FAIL_NA', notes_required_if_fail: false, photo_required_if_fail: false, always_require_notes: false, sort_order: 1 },
  // Certifications items
  { id: INSPECTION_IDS.items.i9, section_id: INSPECTION_IDS.sections.s5, item_code: 'DC-01', item_text: 'CPR/First Aid certifications current', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: false, always_require_notes: false, sort_order: 0 },
  { id: INSPECTION_IDS.items.i10, section_id: INSPECTION_IDS.sections.s5, item_code: 'DC-02', item_text: 'Background checks up to date', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: false, always_require_notes: false, sort_order: 1 },
  // Training Records items
  { id: INSPECTION_IDS.items.i11, section_id: INSPECTION_IDS.sections.s6, item_code: 'TR-01', item_text: 'HIPAA training completed within 12 months', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: false, always_require_notes: false, sort_order: 0 },
  { id: INSPECTION_IDS.items.i12, section_id: INSPECTION_IDS.sections.s6, item_code: 'TR-02', item_text: 'De-escalation training completed', response_type: 'PASS_FAIL_NA', notes_required_if_fail: true, photo_required_if_fail: false, always_require_notes: false, sort_order: 1 },
];

export const mockInspections = [
  {
    id: INSPECTION_IDS.inspections.ins1,
    template_id: INSPECTION_IDS.templates.safety,
    site_id: DEMO_IDS.sites.sleepOut,
    inspector_id: DEMO_IDS.users.manager,
    status: 'submitted',
    area: 'Building A - All Floors',
    notes: 'Routine weekly safety inspection. All areas compliant.',
    started_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    submitted_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    template: { id: INSPECTION_IDS.templates.safety, name: 'Facility Safety & Compliance' },
    site: { id: DEMO_IDS.sites.sleepOut, name: 'Sleep Out' },
    inspection_responses: [
      { id: 'r1', inspection_id: INSPECTION_IDS.inspections.ins1, template_item_id: INSPECTION_IDS.items.i1, response_value: 'PASS', notes: '' },
      { id: 'r2', inspection_id: INSPECTION_IDS.inspections.ins1, template_item_id: INSPECTION_IDS.items.i2, response_value: 'PASS', notes: '' },
      { id: 'r3', inspection_id: INSPECTION_IDS.inspections.ins1, template_item_id: INSPECTION_IDS.items.i3, response_value: 'PASS', notes: '' },
      { id: 'r4', inspection_id: INSPECTION_IDS.inspections.ins1, template_item_id: INSPECTION_IDS.items.i4, response_value: 'FAIL', notes: 'Exposed wiring in Room 203 utility closet. Maintenance notified.' },
    ],
  },
  {
    id: INSPECTION_IDS.inspections.ins2,
    template_id: INSPECTION_IDS.templates.kitchen,
    site_id: DEMO_IDS.sites.friendsFamily,
    inspector_id: DEMO_IDS.users.manager,
    status: 'submitted',
    area: 'Main Kitchen',
    notes: 'Daily kitchen check. Minor issue with food labeling.',
    started_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    submitted_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    template: { id: INSPECTION_IDS.templates.kitchen, name: 'Kitchen Health & Sanitation' },
    site: { id: DEMO_IDS.sites.friendsFamily, name: 'Friends & Family' },
    inspection_responses: [
      { id: 'r5', inspection_id: INSPECTION_IDS.inspections.ins2, template_item_id: INSPECTION_IDS.items.i5, response_value: 'PASS', notes: 'Temp at 38°F' },
      { id: 'r6', inspection_id: INSPECTION_IDS.inspections.ins2, template_item_id: INSPECTION_IDS.items.i6, response_value: 'FAIL', notes: '3 items found without date labels in walk-in cooler' },
      { id: 'r7', inspection_id: INSPECTION_IDS.inspections.ins2, template_item_id: INSPECTION_IDS.items.i7, response_value: 'PASS', notes: '' },
      { id: 'r8', inspection_id: INSPECTION_IDS.inspections.ins2, template_item_id: INSPECTION_IDS.items.i8, response_value: 'PASS', notes: '' },
    ],
  },
  {
    id: INSPECTION_IDS.inspections.ins3,
    template_id: INSPECTION_IDS.templates.documentation,
    site_id: DEMO_IDS.sites.bedstuty,
    inspector_id: DEMO_IDS.users.manager,
    status: 'submitted',
    area: 'Administrative Office',
    notes: 'Monthly documentation audit. Two staff members need updated certifications.',
    started_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    submitted_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    created_at: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    template: { id: INSPECTION_IDS.templates.documentation, name: 'Staff Documentation Review' },
    site: { id: DEMO_IDS.sites.bedstuty, name: 'Bedstuy Hotel' },
    inspection_responses: [
      { id: 'r9', inspection_id: INSPECTION_IDS.inspections.ins3, template_item_id: INSPECTION_IDS.items.i9, response_value: 'FAIL', notes: '2 staff CPR certs expired last month' },
      { id: 'r10', inspection_id: INSPECTION_IDS.inspections.ins3, template_item_id: INSPECTION_IDS.items.i10, response_value: 'PASS', notes: '' },
      { id: 'r11', inspection_id: INSPECTION_IDS.inspections.ins3, template_item_id: INSPECTION_IDS.items.i11, response_value: 'PASS', notes: '' },
      { id: 'r12', inspection_id: INSPECTION_IDS.inspections.ins3, template_item_id: INSPECTION_IDS.items.i12, response_value: 'NA', notes: 'New policy - not yet required' },
    ],
  },
];

// ============= Demo Client Notes =============
const now = new Date();
const hoursAgo = (h: number) => new Date(now.getTime() - h * 60 * 60 * 1000).toISOString();
const daysAgo = (d: number) => new Date(now.getTime() - d * 24 * 60 * 60 * 1000).toISOString();

export const mockClientNotes: Record<string, Array<{
  id: string;
  title: string;
  content: string;
  author: string;
  timestamp: string;
  category: 'general' | 'progress' | 'observation' | 'incident';
}>> = {
  [CLIENT_IDS.c1]: [
    { id: 'cn-1-1', title: 'Intake Assessment Complete', content: 'Client completed full intake assessment. Expressed interest in vocational training programs, specifically HVAC certification. Referred to workforce development.', author: 'Sarah Johnson', timestamp: daysAgo(5), category: 'progress' },
    { id: 'cn-1-2', title: 'Allergy Alert Noted', content: 'Kitchen staff notified of nut and shellfish allergies. Dietary accommodation card issued. Client confirmed understanding of meal protocols.', author: 'Michael Chen', timestamp: daysAgo(4), category: 'observation' },
    { id: 'cn-1-3', title: 'ILP Goal Review', content: 'Reviewed Independent Living Plan goals. Client is making progress on housing search — 3 applications submitted this week. Follow-up scheduled for next Tuesday.', author: 'Sarah Johnson', timestamp: daysAgo(1), category: 'progress' },
  ],
  [CLIENT_IDS.c2]: [
    { id: 'cn-2-1', title: 'Late Return Warning', content: 'Client returned 45 minutes past curfew. Verbal warning issued per shelter policy. No further action needed at this time.', author: 'Staff Member', timestamp: daysAgo(3), category: 'incident' },
    { id: 'cn-2-2', title: 'Job Interview Prep', content: 'Assisted client with resume preparation for warehouse position interview scheduled Thursday. Provided interview clothing from donation closet.', author: 'Michael Chen', timestamp: daysAgo(2), category: 'progress' },
  ],
  [CLIENT_IDS.c3]: [
    { id: 'cn-3-1', title: 'Medical Referral', content: 'Client requested medical referral for persistent back pain. Contacted partner clinic, appointment set for Friday 10AM. Transportation arranged.', author: 'Jennifer Davis', timestamp: daysAgo(2), category: 'general' },
    { id: 'cn-3-2', title: 'Room Inspection Passed', content: 'Weekly room inspection completed. Room in good order. Client maintaining cleanliness standards.', author: 'Staff Member', timestamp: daysAgo(1), category: 'observation' },
  ],
  [CLIENT_IDS.c4]: [
    { id: 'cn-4-1', title: 'Benefits Application Filed', content: 'Assisted client with SNAP benefits application. Documentation submitted to local DSS office. Expected processing time 30 days.', author: 'Lisa Rodriguez', timestamp: daysAgo(7), category: 'progress' },
    { id: 'cn-4-2', title: 'Peer Conflict Resolution', content: 'Mediated minor disagreement between client and another resident regarding shared bathroom schedule. Both parties agreed to posted schedule. No further issues.', author: 'Staff Member', timestamp: daysAgo(1), category: 'incident' },
  ],
  [CLIENT_IDS.c5]: [
    { id: 'cn-5-1', title: 'ESL Class Enrollment', content: 'Client enrolled in evening ESL classes at community center. Classes M/W/F 6-8PM. Schedule adjusted to accommodate.', author: 'Maria Gonzalez', timestamp: daysAgo(6), category: 'progress' },
  ],
};

// ============= Demo Activity Logs =============
export const mockClientActivityLogs: Record<string, Array<{
  id: string;
  action_type: string;
  action_details: any;
  created_at: string;
  profiles: { full_name: string };
}>> = {
  [CLIENT_IDS.c1]: [
    { id: 'al-1-1', action_type: 'check_in', action_details: { client_id: CLIENT_IDS.c1, timestamp: hoursAgo(2) }, created_at: hoursAgo(2), profiles: { full_name: 'Sarah Johnson' } },
    { id: 'al-1-2', action_type: 'acknowledge_reminder', action_details: { client_id: CLIENT_IDS.c1, reminder_text: 'ILP Meeting', timestamp: hoursAgo(1) }, created_at: hoursAgo(1), profiles: { full_name: 'Sarah Johnson' } },
  ],
  [CLIENT_IDS.c2]: [
    { id: 'al-2-1', action_type: 'check_out', action_details: { client_id: CLIENT_IDS.c2, timestamp: hoursAgo(5) }, created_at: hoursAgo(5), profiles: { full_name: 'Michael Chen' } },
  ],
  [CLIENT_IDS.c3]: [
    { id: 'al-3-1', action_type: 'check_in', action_details: { client_id: CLIENT_IDS.c3, timestamp: hoursAgo(3) }, created_at: hoursAgo(3), profiles: { full_name: 'Jennifer Davis' } },
  ],
  [CLIENT_IDS.c4]: [
    { id: 'al-4-1', action_type: 'check_in', action_details: { client_id: CLIENT_IDS.c4, timestamp: hoursAgo(4) }, created_at: hoursAgo(4), profiles: { full_name: 'Staff Member' } },
    { id: 'al-4-2', action_type: 'update_client', action_details: { client_id: CLIENT_IDS.c4, new_status: 'unbedded', timestamp: hoursAgo(6) }, created_at: hoursAgo(6), profiles: { full_name: 'Lisa Rodriguez' } },
  ],
  [CLIENT_IDS.c5]: [
    { id: 'al-5-1', action_type: 'check_in', action_details: { client_id: CLIENT_IDS.c5, timestamp: hoursAgo(3) }, created_at: hoursAgo(3), profiles: { full_name: 'Maria Gonzalez' } },
  ],
};

// ============= Demo Service Logs (per client) =============
export const mockClientServiceLogs: Record<string, Array<{
  id: string;
  service_type: string;
  quantity: number;
  notes: string;
  created_at: string;
  profiles: { full_name: string };
}>> = {
  [CLIENT_IDS.c1]: [
    { id: 'sl-1-1', service_type: 'Transit', quantity: 1, notes: 'Weekly transit card', created_at: hoursAgo(1), profiles: { full_name: 'Sarah Johnson' } },
    { id: 'sl-1-2', service_type: 'Meal - Lunch', quantity: 1, notes: 'Lunch', created_at: hoursAgo(3), profiles: { full_name: 'Staff Member' } },
    { id: 'sl-1-3', service_type: 'Beverage', quantity: 1, notes: 'Juice', created_at: hoursAgo(4), profiles: { full_name: 'Staff Member' } },
  ],
  [CLIENT_IDS.c2]: [
    { id: 'sl-2-1', service_type: 'Transit', quantity: 1, notes: 'Transit card issued', created_at: hoursAgo(6), profiles: { full_name: 'Michael Chen' } },
    { id: 'sl-2-2', service_type: 'Meal - Breakfast', quantity: 1, notes: 'Breakfast', created_at: hoursAgo(7), profiles: { full_name: 'Staff Member' } },
  ],
  [CLIENT_IDS.c3]: [
    { id: 'sl-3-1', service_type: 'Laundry', quantity: 1, notes: 'Laundry card', created_at: hoursAgo(2), profiles: { full_name: 'Jennifer Davis' } },
    { id: 'sl-3-2', service_type: 'Meal - Lunch', quantity: 1, notes: 'Lunch', created_at: hoursAgo(3), profiles: { full_name: 'Staff Member' } },
    { id: 'sl-3-3', service_type: 'Beverage', quantity: 3, notes: 'Juice', created_at: hoursAgo(4), profiles: { full_name: 'Staff Member' } },
  ],
  [CLIENT_IDS.c4]: [
    { id: 'sl-4-1', service_type: 'Transit', quantity: 1, notes: 'Transit card', created_at: hoursAgo(3), profiles: { full_name: 'Lisa Rodriguez' } },
    { id: 'sl-4-2', service_type: 'Meal - Dinner', quantity: 1, notes: 'Dinner', created_at: hoursAgo(1), profiles: { full_name: 'Staff Member' } },
  ],
  [CLIENT_IDS.c5]: [
    { id: 'sl-5-1', service_type: 'Laundry', quantity: 1, notes: 'Laundry card issued', created_at: hoursAgo(2), profiles: { full_name: 'Maria Gonzalez' } },
    { id: 'sl-5-2', service_type: 'Meal - Lunch', quantity: 2, notes: 'Lunch x2', created_at: hoursAgo(3), profiles: { full_name: 'Staff Member' } },
  ],
};